package org.hs_soft.runmynesto.domain.model.home.dashboard.dashboard_config


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GetDashboardDSGeo(
    @SerialName("coordinates")
    val coordinates: String?,
    @SerialName("google_map_url")
    val googleMapUrl: String?,
    @SerialName("id")
    val id: String?,
    @SerialName("__typename")
    val typename: String?
)